export function expandCornerRadius(cornerRadius, expansion) {
    if (cornerRadius === undefined) {
        return;
    }
    if (expansion === undefined) {
        return cornerRadius;
    }
    return {
        topLeft: Math.max(0, (cornerRadius?.topLeft ?? 0) + expansion),
        topRight: Math.max(0, (cornerRadius?.topRight ?? 0) + expansion),
        bottomLeft: Math.max(0, (cornerRadius?.bottomLeft ?? 0) + expansion),
        bottomRight: Math.max(0, (cornerRadius?.bottomRight ?? 0) + expansion),
    };
}
//# sourceMappingURL=expandCornerRadius.js.map